<template>
  <div class="container">
    <el-page-header class="page-header" @back="goBack" :content="header">
      </el-page-header>
      <div class="main" style="display: flex">
        <el-form ref="ruleForm" :model="form" :rules="rules" label-width="12.0rem" style="width: 80.0rem">
          <div class="form-header">
            <el-form-item prop="scope" label="发送对象：" v-if="this.$route.query.id || this.$route.query.state">
              <el-radio-group v-model="form.scope" @change="changeScope">
                <el-radio :label="1" disabled>通用</el-radio>
                <el-radio :label="2" disabled>部分员工适用</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item prop="scope" label="发送对象：" v-else>
              <el-radio-group v-model="form.scope" @change="changeScope">
                <el-radio :label="1">通用</el-radio>
                <el-radio :label="2">部分员工适用</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item v-if="form.scope === 2" label="添加成员：" prop="userid">
              <div class="person">
                <el-tag v-for="item of names" :key="item" effect="plain"  style="margin-right: 12px">
                  {{ item }}
                </el-tag>
              </div>
              <el-button class="addBtn" icon="el-icon-plus" @click="addContact" v-if="
                this.$route.query.id || this.$route.query.state
                  ? isShowbtn
                  : true
              ">前往添加</el-button>
            </el-form-item>
          </div>
          <div class="form-content">
            <el-form-item prop="content" label="欢迎语内容：">
              <el-input clearable type="textarea" autosize="true" placeholder="请输入内容" v-model="form.content"></el-input>
            </el-form-item>
            <el-form-item prop="type" label="附件类型：">
              <el-checkbox-group v-model="checkList" @change="changeType">
                <el-checkbox label="image">图片</el-checkbox>
                <el-checkbox label="link">图文</el-checkbox>
                <el-checkbox label="miniprogram">小程序</el-checkbox>
                <el-checkbox label="video">视频</el-checkbox>
                <el-checkbox label="file">文件</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <!-- 图片部分 -->
            <el-form-item prop="image_pic_url" v-if="this.checkList.includes('image')" label="图片">
              <el-upload class="upload-demo" :action="
                this.axios.defaults.baseURL +
                '/api/Alioss/upload_temp_uploadimg'
              " :data="upParams" :before-upload="handleBeforeUpload" :on-success="handleSuccess1"
                :before-remove="beforeRemove" :on-remove="clearImg" :file-list="fileList1" list-type="picture"
                accept=".jpg,.png" :limit="1">
                <el-button type="primary" @click="clearImage">
                  上传图片
                  <i class="el-icon-upload el-icon--right"></i>
                </el-button>
                <div slot="tip" class="el-upload__tip">
                  只能上传JPG,PNG格式文件，且不超过10MB
                </div>
              </el-upload>
            </el-form-item>
            <!-- 图文部分 -->
            <el-form-item prop="link_title" v-if="this.checkList.includes('link')" label="标题：">
              <el-input clearable v-model="form.link_title" placeholder="请输入图文标题"></el-input>
            </el-form-item>
            <el-form-item prop="link_url" v-if="this.checkList.includes('link')" label="链接：">
              <el-input clearable v-model="form.link_url" placeholder="请输入图文链接"></el-input>
            </el-form-item>
            <el-form-item prop="link_picurl" v-if="this.checkList.includes('link')" label="封面">
              <el-upload class="upload-demo" :action="
                this.axios.defaults.baseURL +
                '/api/Alioss/upload_temp_uploadimg'
              " :data="upParams" :before-upload="handleBeforeUpload" :on-success="handleSuccess2"
                :before-remove="beforeRemove" :file-list="fileList2" list-type="picture" accept=".jpg,.png" :limit="1">
                <el-button type="primary" @click="clearLink">
                  上传封面
                  <i class="el-icon-upload el-icon--right"></i>
                </el-button>
                <div slot="tip" class="el-upload__tip">
                  只能上传JPG,PNG格式文件，且不超过10MB
                </div>
              </el-upload>
            </el-form-item>
            <el-form-item v-if="this.checkList.includes('link')" prop="link_desc" label="描述：">
              <el-input clearable  type="textarea" autosize="true" placeholder="请输入图文描述" v-model="form.link_desc"></el-input>
            </el-form-item>
            <!-- 小程序部分 -->
            <el-form-item prop="miniprogram_title" v-if="this.checkList.includes('miniprogram')" label="小程序标题：">
              <el-input clearable v-model="form.miniprogram_title" placeholder="请输入小程序标题"></el-input>
            </el-form-item>
            <el-form-item prop="miniprogram_appid" v-if="this.checkList.includes('miniprogram')" label="小程序ID：">
              <el-input clearable v-model="form.miniprogram_appid" placeholder="请输入小程序ID"></el-input>
            </el-form-item>
            <el-form-item prop="miniprogram_page" v-if="this.checkList.includes('miniprogram')" label="小程序路径：">
              <el-input clearable v-model="form.miniprogram_page" placeholder="请输入小程序路径"></el-input>
            </el-form-item>
            <el-form-item prop="mini_pic_url" v-if="this.checkList.includes('miniprogram')" label="小程序封面">
              <el-upload class="upload-demo" :action="
                this.axios.defaults.baseURL +
                '/api/Alioss/upload_temp_uploadimg'
              " :data="upParams" :before-upload="handleBeforeUpload" :on-success="handleSuccess3"
                :before-remove="beforeRemove" :file-list="fileList3" list-type="picture" accept=".jpg,.png" :limit="1">
                <el-button type="primary" @click="clearMiniProgram">
                  上传封面
                  <i class="el-icon-upload el-icon--right"></i>
                </el-button>
                <div slot="tip" class="el-upload__tip">
                  只能上传JPG,PNG格式文件，且不超过10MB
                </div>
              </el-upload>
            </el-form-item>
            <!-- 视频部分 -->
            <el-form-item prop="video_url" v-if="this.checkList.includes('video')" label="视频">
              <el-upload class="upload-demo" :action="
                this.axios.defaults.baseURL +
                '/api/Alioss/upload_temp_uploadimg'
              " :show-file-list="false" :data="upParamsV" :before-upload="handleBeforeUploadV"
                :on-success="handleSuccess4" :before-remove="beforeRemove" :file-list="fileList4" list-type="text"
                accept=".mp4" :limit="1">
                <el-button type="primary" @click="clearVideo">
                  上传视频
                  <i class="el-icon-upload el-icon--right"></i>
                </el-button>
                <div slot="tip" class="el-upload__tip">
                  只能上传MP4格式文件，且不超过10MB
                </div>
              </el-upload>
              <div class="el-upload__tip" v-show="loading2">
                上传中...<i class="el-icon-loading" style="color: #36a3f7; margin-left: 5px"></i>
              </div>
            </el-form-item>
            <el-form-item v-if="isShowVideo" label="">
              <div class="el-upload__tip" v-show="this.$route.query.id != ''">
                {{ form.video_name
                }}<i class="el-icon-upload-success el-icon-circle-check" style="color: green; margin-left: 5px"></i>
                <i class="el-icon-close" style="margin-left: 2.0rem;color:#188000" @click="removevideo"></i>
            </div>
              <div>
                <video style="width: 224px; height: 126px" :src="form.video_url" controls="controls"></video>
              </div>
            </el-form-item>
            <!-- 文件部分 -->
            <el-form-item prop="file_url" v-if="this.checkList.includes('file')" label="文件">
              <el-upload class="upload-demo" :action="
                this.axios.defaults.baseURL +
                '/api/Alioss/upload_temp_uploadimg'
              " :show-file-list="false" :data="upParamsF" :before-upload="handleBeforeUploadF"
                :on-success="handleSuccess5" :before-remove="beforeRemove" :file-list="fileList5" list-type="text"
                accept="" :limit="1">
                <el-button type="primary" @click="clearFile">
                  上传文件
                  <i class="el-icon-upload el-icon--right"></i>
                </el-button>
                <div slot="tip" class="el-upload__tip">不能超过20MB</div>
              </el-upload>
              <div class="el-upload__tip" v-show="loading1">
                上传中...<i class="el-icon-loading" style="color: #36a3f7; margin-left: 5px"></i>
              </div>
            </el-form-item>
            <el-form-item v-if="isShowFile">
              <div class="el-upload__tip" v-show="this.$route.query.id != ''">
                {{ form.file_name
                }}<i class="el-icon-upload-success el-icon-circle-check" style="color: green; margin-left: 5px"></i>
                  <i class="el-icon-close" style="margin-left: 2.0rem;color:#188000" @click="removeflie"></i>
            </div>
            </el-form-item>
          </div>
          <div class="form-footer">
            <el-form-item label-width="3.0rem">
              <el-button type="primary" v-if="faterid == 0" @click="submitForm('ruleForm')">立即创建</el-button>
              <el-button v-else type="primary" @click="submitForm('ruleForm')">确定编辑</el-button>
              <!-- <el-button style="margin-left: 2.0rem" plain @click="$router.back()"
                >取消</el-button
              > -->
            </el-form-item>
          </div>
        </el-form>
        <div class="con-right" :style="'background-image:url(' + backImg + ')'">
      <!-- <img
        class="mobile-img"
        src="../../../assets/smartPhone.png"
        alt=""
        srcset=""
      /> -->
      <div class="mobile">
        <div class="list">
          <!-- 欢迎语内容 -->
          <div class="list-item" v-show="form.content">
            <div class="list-item-l">
              <img class="list-item-l-avatar" src="../../../assets/logoCircle.png" />
            </div>
            <div class="list-item-r" style="
                  width: 70%;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  background: #fff;
                  padding: 5px;
                  border-radius: 4px;
                ">
              {{ form.content }}
            </div>
          </div>
          <!-- 图片 -->
          <div class="list-item" v-show="this.checkList.includes('image') && form.image_pic_url">
            <div class="list-item-l">
              <img class="list-item-l-avatar" src="../../../assets/logoCircle.png" />
            </div>
            <div class="list-item-r">
              <img :src="form.image_pic_url" />
            </div>
          </div>
          <!-- 图文 -->
          <div class="list-item" v-show="this.checkList.includes('link') && form.link_title">
            <div class="list-item-l">
              <img class="list-item-l-avatar" src="../../../assets/logoCircle.png" />
            </div>
            <div class="list-item-b-a">
              <div style="width: 10.0rem; margin-right: 1.0rem">
                <div class="list-item-r-t">{{ form.link_title }}</div>
                <div class="list-item-r-t">{{ form.link_url }}</div>
                <div class="list-item-r-t">{{ form.link_desc }}</div>
              </div>
              <div class="list-item-r-d" v-if="form.link_picurl">
                <img :src="form.link_picurl" />
              </div>
            </div>
          </div>
          <!-- 小程序 -->
          <div class="list-item" v-show="
            this.checkList.includes('miniprogram') && form.miniprogram_title
          ">
            <div class="list-item-l">
              <img class="list-item-l-avatar" src="../../../assets/logoCircle.png" />
            </div>
            <div class="list-item-b-a">
              <div style="width: 10.0rem; margin-right: 1.0rem">
                <div class="list-item-r-t" style="display: flex; align-items: center">
                  {{ form.miniprogram_title }}
                  <img style="width: 1.1rem; margin-left: 5px" src="../../../assets/小程序 (1).png" alt="" />
                </div>
              </div>
              <div class="list-item-r-d" v-if="form.mini_pic_url">
                <img :src="form.mini_pic_url" />
              </div>
            </div>
          </div>
          <!-- 视频 -->
          <div class="list-item" v-show="this.checkList.includes('video') && form.video_url">
            <div class="list-item-l">
              <img class="list-item-l-avatar" src="../../../assets/logoCircle.png" />
            </div>
            <div class="list-item-r">
              <div class="list-item-r-u">
                <video style="width: 13.0rem; height: 6.0rem" :src="form.video_url" controls="controls"></video>
              </div>
            </div>
          </div>
          <!-- 文件 -->
          <div class="list-item" v-show="this.checkList.includes('file') && form.file_url">
            <div class="list-item-l">
              <img class="list-item-l-avatar" src="../../../assets/logoCircle.png" />
            </div>
            <div class="list-item-r file">
              <div>{{ form.file_name }}</div>
              <div class="img">
                <img src="../../../assets/文件 (2).png" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
        </div>
      </div>


    <right-people ref="dialog" :checkbox="checkbox" @handleSelect="handleSelect"></right-people>
  </div>
</template>
<script>
import axios from "axios";
import qs from "qs";
import rightPeople from '@/components/drawer/rightPeople';
export default {
  components: {
    rightPeople
  },
  data() {
    return {
      form: {
        scope: 1,
        userid: "",
        content: "",
        msgtype: [], //如果五种类型都不选就传 "0"
        image_media_id: "",
        image_pic_url: "",
        link_title: "",
        link_picurl: "",
        link_desc: "",
        link_url: "",
        miniprogram_title: "",
        miniprogram_pic_media_id: "",
        miniprogram_appid: "",
        miniprogram_page: "/pages/page/index.html",
        mini_pic_url: "",
        video_media_id: "",
        file_media_id: "",
        video_url: "",
        video_name: "",
        file_url: "",
        file_name: "",
      },
      rules: {
        content: [
          { required: true, message: "请输入欢迎语内容", trigger: ['blur', 'change'] },
        ],
        image_pic_url: [
          { required: true, message: "请上传图片", trigger: ['blur', 'change'] },
        ],
        link_title: [
          { required: true, message: "请输入图文标题", trigger: ['blur', 'change'] },
        ],
        link_url: [{ required: true, message: "请输入链接", trigger: ['blur', 'change']}],
        miniprogram_title: [
          { required: true, message: "请输入小程序标题", trigger: ['blur', 'change'] },
        ],
        miniprogram_appid: [
          { required: true, message: "请输入小程序appID", trigger: ['blur', 'change']},
        ],
        miniprogram_page: [
          { required: true, message: "请输入小程序页面路径", trigger: ['blur', 'change'] },
        ],
        mini_pic_url: [
          { required: true, message: "请上传小程序封面",trigger: ['blur', 'change'] },
        ],
        video_url: [{ required: true, message: "请上传视频", trigger: ['blur', 'change'] }],
        file_url: [{ required: true, message: "请上传文件", trigger: ['blur', 'change'] }],
      },
      fileList1: [],
      fileList2: [],
      fileList3: [],
      fileList4: [],
      fileList5: [],
      tooken: "",
      checkbox: false,
      names: [],
      upParams: {},
      upParamsV: {},
      upParamsF: {},
      module: "",
      checkList: [],
      msgType: "",
      listQuery: {
        page: 1,
        limit: 20,
      },
      one: "false",
      two: "true",
      loading1: false,
      loading2: false,
      backImg: require("@/assets/smartPhone.png"),
      header: "新建欢迎语",
      faterid: 0,
    };
  },
  mounted() {
    if (window.localStorage.getItem("storuser")) {
      let userinfo = JSON.parse(window.localStorage.getItem("storuser"));
      this.tooken = userinfo;
      this.upParams.account_id = this.tooken.account_id;
      this.upParamsV.account_id = this.tooken.account_id;
      this.upParamsV.type = "2";
      this.upParamsF.account_id = this.tooken.account_id;
      this.upParamsF.type = "3";
    }
    if (this.$route.query.state) {
      this.form.scope = 2;
      this.names = this.$route.query.user_name.split(",");
      this.form.userid = this.$route.query.userid;
    }
    if (this.$route.query.id) {
      this.faterid = this.$route.query.id
      this.getData();
      this.header = "编辑欢迎语";
    } else {
      this.header = "新建欢迎语";
    }
  },
  computed: {
    isShowVideo() {
      return this.checkList.includes("video") && this.form.video_url.length > 0;
    },
    isShowFile() {
      return this.checkList.includes("file") && this.form.file_url.length > 0;
    },
    isShowbtn() {
      return this.$route.query.user_name && this.$route.query.state == 0;
    },
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    getData() {
      this.axios
        .post(
          "/crm/AssistantWelcomeNew/getWelcome",
          qs.stringify({
            account_id: this.tooken.account_id,
            page: this.listQuery.page,
            number_page: this.listQuery.limit,
            id: this.$route.query.id,
            state: this.$route.query.state,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.code == 1) {
            const data = res.data.data.data[0];
            this.form.content = data.content;
            this.form.userid = data.userid;
            this.names = data.user_name.split(",");
            this.form.scope = data.scope;
            this.checkList = data.msgtype.split(",");
            this.msgType = data.msgtype;
            this.form.image_media_id = data.image_media_id;
            this.form.image_pic_url = data.image_pic_url;
            this.form.link_title = data.link_title;
            this.form.link_desc = data.link_desc;
            this.form.link_url = data.link_url;
            this.form.link_picurl = data.link_picurl;
            this.form.miniprogram_pic_media_id = data.miniprogram_pic_media_id;
            this.form.miniprogram_title = data.miniprogram_title;
            this.form.miniprogram_appid = data.miniprogram_appid;
            this.form.miniprogram_page = data.miniprogram_page;
            this.form.mini_pic_url = data.mini_pic_url;
            this.form.video_media_id = data.video_media_id;
            this.form.video_url = data.video_url;
            this.form.video_name = data.video_name;
            this.form.file_url = data.file_url;
            this.form.file_media_id = data.file_media_id;
            this.form.file_name = data.file_url_name;
            if (data.image_pic_url != "") {
              this.fileList1.push({ url: data.image_pic_url });
            }
            if (data.link_picurl != "") {
              this.fileList2.push({ url: data.link_picurl });
            }
            if (data.mini_pic_url != "") {
              this.fileList3.push({ url: data.mini_pic_url });
            }
            if (data.video_url != "") {
              let fileObj = {
                url: data.video_url,
                name: data.video_name,
              };
              this.fileList4.push(fileObj);
            }
            if (data.file_url != "") {
              let fileObj = {
                url: data.file_url,
                name: data.file_url_name,
              };
              this.fileList5.push(fileObj);
            }
          } else if (res.data.code == 0) {
            this.$message.error(res.data.msg);
          }
        })
        .catch(function (err) { });
    },
    changeType() {
      if (!this.checkList.includes("image")) {
        this.form.image_media_id = "";
        this.form.image_pic_url = "";
      }
      if (!this.checkList.includes("link")) {
        this.form.link_title = "";
        this.form.link_picurl = "";
        this.form.link_desc = "";
        this.form.link_url = "";
      }
      if (!this.checkList.includes("miniprogram")) {
        this.form.miniprogram_title = "";
        this.form.miniprogram_pic_media_id = "";
        this.form.miniprogram_appid = "";
        this.form.mini_pic_url = "";
      }
      if (!this.checkList.includes("video")) {
        this.form.video_url = "";
        this.form.video_media_id = "";
      }
      if (!this.checkList.includes("file")) {
        this.form.file_media_id = "";
        this.form.file_url = "";
      }
    },
    clearImage() {
      this.fileList1 = [];
    },
    clearLink() {
      this.fileList2 = [];
    },
    clearMiniProgram() {
      this.fileList3 = [];
    },
    clearVideo() {
      this.fileList4 = [];
    },
    clearFile() {
      this.fileList5 = [];
    },
    handleBeforeUpload(file) {
      const size = file.size / 1024 / 1024;
      if (this.checkList.includes("image")) {
        if (size > 10) {
          this.$message({
            message: "上传图片文件过大",
            type: "error",
          });
          return false;
        }
      }
      if (this.checkList.includes("link")) {
        if (size > 10) {
          this.$message({
            message: "上传图文过大",
            type: "error",
          });
          return false;
        }
      }
      if (this.checkList.includes("miniprogram")) {
        if (size > 10) {
          this.$message({
            message: "上传小程序封面过大",
            type: "error",
          });
          return false;
        }
      }
    },
    handleBeforeUploadV(file) {
      this.loading2 = true;
      const size = file.size / 1024 / 1024;
      if (this.checkList.includes("video")) {
        if (size > 10) {
          this.$message({
            message: "上传视频文件过大",
            type: "error",
          });
          return false;
        }
      }
    },
    handleBeforeUploadF(file) {
      this.loading1 = true;
      const size = file.size / 1024 / 1024;
      if (this.checkList.includes("file")) {
        if (size > 20) {
          this.$message({
            message: "上传文件过大",
            type: "error",
          });
          return false;
        }
      }
    },
    handleSuccess1(response, file, fileList) {
      this.form.image_pic_url = response.data.url;
      this.form.image_media_id = response.data.media_id;
      this.$message({
        message: "上传成功",
        type: "success",
      });
    },
    handleSuccess2(response, file, fileList) {
      this.form.link_picurl = response.data.url;
      this.$message({
        message: "上传成功",
        type: "success",
      });
    },
    handleSuccess3(response, file, fileList) {
      this.form.miniprogram_pic_media_id = response.data.media_id;
      this.form.mini_pic_url = response.data.url;
      this.$message({
        message: "上传成功",
        type: "success",
      });
    },
    handleSuccess4(response, file, fileList) {
      this.loading2 = false;
      this.form.video_media_id = response.data.media_id;
      this.form.video_url = response.data.url;
      this.form.video_name = response.data.urlname;
      this.$message({
        message: "上传成功",
        type: "success",
      });
    },
    handleSuccess5(response, file, fileList) {
      this.loading1 = false;
      this.form.file_media_id = response.data.media_id;
      this.form.file_url = response.data.url;
      this.form.file_name = response.data.urlname;
      this.$message({
        message: "上传成功",
        type: "success",
      });
    },
    beforeRemove(file, fileList) {
      this.form.url = [];
      this.fileList = [];
    },
    addContact() {
      this.module = "getAddressBook";
      this.checkbox = true;
      this.isGroup = true;
      this.$refs.dialog.open();
    },
    handleSelect(person) {
      switch (this.module) {
        case "getWelcomeOne":
          this.form.userid = person.userid;
          this.names = String(user);
          break;
        case "getAddressBook":
          const userid = [];
          const user = [];
          person.map((item) => {
            userid.push(item.userid);
            user.push(item.name);
          });
          this.form.userid = userid.join();
          this.names = user;
          console.log(this.names);
          break;
        default:
          break;
      }
    },
    changeScope(label) {
      if (label == 1) {
        this.one = true;
        this.two = false;
      } else {
        this.one = false;
        this.two = true;
      }
      switch (label) {
        case "1":
          Reflect.deleteProperty(this.rules, "userid");
          break;
        default:
          this.rules.userid = [
            {
              required: true,
              message: "请选择成员",
              trigger: "blur",
            },
          ];
          break;
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submit();
        } else {
          return false;
        }
      });
    },
    submit() {
      const url = this.$route.query.id ? "editWelcome" : "addWelcome";
      if (this.checkList == []) {
        this.msgType = "0";
      } else {
        this.msgType = this.checkList.join();
      }
      this.axios
        .post(
          `/crm/AssistantWelcomeNew/${url}`,
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            scope: this.form.scope,
            userid: this.form.userid,
            id: this.$route.query.id,
            state: this.$route.query.state,
            content: this.form.content,
            msgtype: this.msgType,
            image_media_id: this.form.image_media_id,
            image_pic_url: this.form.image_pic_url,
            link_title: this.form.link_title,
            link_picurl: this.form.link_picurl,
            link_desc: this.form.link_desc,
            link_url: this.form.link_url,
            miniprogram_title: this.form.miniprogram_title,
            miniprogram_pic_media_id: this.form.miniprogram_pic_media_id,
            miniprogram_appid: this.form.miniprogram_appid,
            miniprogram_page: this.form.miniprogram_page,
            mini_pic_url: this.form.mini_pic_url,
            video_url: this.form.video_url,
            video_media_id: this.form.video_media_id,
            file_media_id: this.form.file_media_id,
            file_url: this.form.file_url,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.code == 1) {
            this.$message.success(res.data.msg);
            this.$router.go(-1);
          } else if (res.data.code == 0) {
            this.$message.error(res.data.msg);
          }
        })
        .catch(function (err) { });
    },
    /*点击 X 清除手机上的图片*/
    clearImg(file, fileList1) {
      console.log('clearImg')
      this.fileList1 = []
      this.form.image_pic_url = ""

    },
    removeflie(){
      this.$confirm("是否删除该文件?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(()=>{
      this.form.file_name=''
      this.form.file_url=''
      this.fileList5=[]
      }).catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    removevideo(){
      this.$confirm("是否删除该视频?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(()=>{
        this.form.video_name=''
      this.form.video_url=''
      this.fileList4=[]
      }).catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });

    },
  },
};
</script>
<style scoped>
::v-deep .el-link.el-link--primary {
  display: inline-block;
  width: 100%;
}

.con-left {
  width: 50%;
}

.header {
  line-height: 4.0rem;
  border-bottom: .1rem solid rgb(241, 239, 239);
}

.addBtn {
  margin-top: 2.0rem;
}

.main {
  margin-top: 4.0rem;
}

.form-header,
.form-content {
  /* padding-top: 22px; */
  padding-right: 22px;
  overflow: hidden;
}

/* .form-content, */
.form-footer {
  margin-top: 2.0rem;
}

.el-upload-list__item-thumbnail {
  width: 10.0rem;
  height: 10.0rem;
}

/* .container {
  display: flex;
} */

.con-right {
  width: 375px;
  margin-left: 20.0rem;
  height: 642px;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  margin-top: -2rem;
}

.mobile {
  position: relative;
  top: 11.0rem;
  left: 45px;
  width: 70%;
}

.mobile-img {
  width: 19.59%;
  position: absolute;
}

.list-item {
  display: flex;
  margin: 1.0rem 15px;
}

.list-item-l {
  margin-right: 6px;
}

.list-item-l img {
  width: 4.0rem;
  border-radius: 50%;
}

.list-item-r,
.list-item-b-a {
  color: #666;
  font-size: 12px;
}

.list-item-b-a {
  background: #fff;
  border: .1rem solid #eee;
  padding: 1.0rem;
  border-radius: 4px;
  display: flex;
  align-items: center;
}

.list-item-r img {
  width: 84%;
}

.list-item-r-d img {
  width: 84%;
  height: 5.0rem;
}

.list-item-r-t {
  line-height: 1.5;
}

.list-item-b-a .list-item-r-t {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.file {
  width: 70%;
  overflow: hidden;
  text-overflow: ellipsis;
  background: #fff;
  padding: 5px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.file img {
  width: 100%;
}

.img {
  width: 4.0rem;
  height: 45px;
  background: #409eff;
  border-radius: 4px;
  text-align: center;
}
.container{
  position: relative;
    top: -4px;

}
.main{
    margin-top:.0rem;
    background: #fff;
    padding: 2.0rem;
    border-radius:.8rem;

}
.el-form-item {
    margin-bottom: 4.0rem;
}
.el-textarea,.el-input{
  width:47.0rem;
}
</style>
